import dayjs from "dayjs";

export default function (jsonString: string) {
  return JSON.parse(jsonString, (_key, value: string) => {
    // Look for values that looks like dates and transform them to dates.
    // Check if string value is date with ISO-8601 format
    // Regex generated by community : https://stackoverflow.com/a/43931246
    const dateValidationRegex =
      /^(?:[1-9]\d{3}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[1-9]\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00)-02-29)T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d{1,9})?(?:Z|[+-][01]\d:[0-5]\d)$/;
    if (dateValidationRegex.test(value)) {
      return dayjs(value).toDate();
    }
    return value;
  });
}
